import { __assign, __rest } from "tslib";
import React from 'react';
import { PrintOnlyImageSource } from './printOnlySource';
var ImageRenderer = function (props) {
    var customImageRenderer = props.customImageRenderer, imageProps = __rest(props, ["customImageRenderer"]); // customImageRenderer is not valid for dom elements.
    if (typeof customImageRenderer === 'function') {
        return customImageRenderer(props);
    }
    else if (typeof props.src === 'string') {
        return React.createElement("img", __assign({ alt: props.alt }, imageProps));
    }
    else if (typeof props.src === 'object') {
        return (React.createElement("picture", { id: "multi_picture_" + props.id, key: "multi_picture_" + props.id },
            props.src.map(function (src) {
                return src.forPrinting ? (React.createElement(PrintOnlyImageSource, { srcSet: src.dpr, type: "image/" + src.type })) : (React.createElement("source", { srcSet: src.dpr || src.url, type: "image/" + src.type }));
            }),
            React.createElement("img", __assign({ alt: props.alt }, imageProps, { src: props.src[props.src.length - 1].url }))));
    }
    else {
        return null;
    }
};
export default ImageRenderer;
//# sourceMappingURL=imageRenderer.js.map